import { createStyle } from '@gluestack-style/react';

export const AlertIcon = createStyle({
  props: {
    size: 'md',
  },
});
